import { MKTU_CLASS_CATEGORY } from '@/models/Mktu'
import { MktuClass, MktuClassWord } from '@/services/Api/generated'
import { exportMktuListToFile } from '@/shared/Mktu/utils'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { mktuClassesList } from '@/store/Mktu/MktuClassesList'
import { SearchMktuClassStore } from '@/store/Mktu/SearchMktuClass'
import { Loader } from '@/helpers/Loader'
import { makeAutoObservable } from 'mobx'

export class MktuDataStore {
  mktuClassesList = mktuClassesList
  searchStore = new SearchMktuClassStore(this.mktuClassesList)
  selectedMktuClasses: MktuClassStore[] = []

  exportFile = new Loader(async () => {
    await exportMktuListToFile(this.selectedMktuClasses)
  }, {})

  setAllClassData = (classes: MktuClass[]) => {
    if (this.mktuClassesList.classes.length == 0) {
      this.mktuClassesList.processData(classes)
    }
  }

  setClassData = (loadedMktuClass: MktuClass, loadedWords: MktuClassWord[]) => {
    const existStore = this.mktuClassesList.classes.find(
      (mktuClass) => mktuClass.number == loadedMktuClass.classNumber
    )
    if (loadedWords.length > 0) {
      if (existStore != null) {
        existStore.setWords(loadedWords)
      } else {
        const mktuClassStore = new MktuClassStore(loadedMktuClass)
        mktuClassStore.setWords(loadedWords)
        this.mktuClassesList.classes.push(mktuClassStore)
      }
    }
  }

  applySelectedClasses = () => {
    this.selectedMktuClasses = this.searchStore.selectedFoundClasses
  }

  get productMktuClasses() {
    return this.mktuClassesList.classes.filter(
      (mktuClassStore) => mktuClassStore.type == MKTU_CLASS_CATEGORY.PRODUCT
    )
  }
  get serviceMktuClasses() {
    return this.mktuClassesList.classes.filter(
      (mktuClassStore) => mktuClassStore.type == MKTU_CLASS_CATEGORY.SERVICE
    )
  }

  get sortedProductMktuClasses() {
    return this.productMktuClasses.sort((a, b) =>
      a.number > b.number ? 1 : -1
    )
  }

  get sortedServiceMktuClasses() {
    return this.serviceMktuClasses.sort((a, b) =>
      a.number > b.number ? 1 : -1
    )
  }

  reset = () => {
    this.selectedMktuClasses = []
  }

  removeSelectedClass = (classNumber: number) => {
    this.selectedMktuClasses = this.selectedMktuClasses.filter(
      (mktuClass) => mktuClass.number !== classNumber
    )
  }

  removeSelectedWord = (classNumber: number, word: MktuClassWord) => {
    const selectedClass = this.selectedMktuClasses.find(
      (mktuClass) => mktuClass.number === classNumber
    )

    if (selectedClass == null) {
      return
    }

    selectedClass.setSelectedWordsNames(
      selectedClass.selectedWordsNames.filter(
        (selectedWordName) => selectedWordName !== word.word
      )
    )
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }
}

export const mktuDataStore = new MktuDataStore()
